import styled from "styled-components";

export const FestivalCompetitionPosterWrapper = styled.div``;

export const FestivalCompetitionPosterImage = styled.div`
  width: 100%;
  height: auto;
  aspect-ratio: 288 / 400; /* 비율 고정 */
  min-width: 288px;
  min-height: 400px;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
